import { t } from '@if/core/i18n'
import { ESourceSystem } from '@if/core/types'
import * as yup from '@if/core/yup'
import { EMerchantReportFrequency } from './Constants'

const bannerNameRegex = /^[a-zA-Z0-9&.,'’\- ]+$/
const bannerSchema = {
  name: yup
    .string()
    .matches(bannerNameRegex, () => t('common.errors.bannerNameInvalid'))
    .max(100, () => t('common.errors.tooManyCharacters'))
    .required(),
  serviceCategory: yup.string().required(),
  email: yup
    .string()
    .email()
    .max(256, () => t('common.errors.tooManyCharacters')),
  phone: yup.string().validCanadianPhone().notRequired(),
  website: yup
    .string()
    .url()
    .notRequired()
    .max(256, () => t('common.errors.tooManyCharacters')),
  address: yup
    .string()
    .notRequired()
    .max(100, () => t('common.errors.tooManyCharacters')),
  city: yup
    .string()
    .notRequired()
    .max(50, () => t('common.errors.tooManyCharacters')),
  province: yup.string().notRequired(),
  zipCode: yup.string().notRequired(),
  languageId: yup.number().required(),
  sourceSystem: yup.string().default(ESourceSystem.Alis).notRequired(),
  id: yup.string().notRequired(),
  reportGenerationFrequency: yup
    .string()
    .nullable()
    .oneOf(['', ...Object.values(EMerchantReportFrequency)])
    .default(EMerchantReportFrequency.never),
  reportRecipientsEmailList: yup.array().of(yup.string().email().required()).default([]),
  worksheetByMerchant: yup.boolean().required().default(false),
}
export const BannerSchema = yup.object().shape(bannerSchema)

export type BannerDto = yup.InferType<typeof BannerSchema>
